(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reducedMotion && 'IntersectionObserver' in window) {
    document.body.classList.add('mt-reveal-ready');
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
    );
    document.querySelectorAll('[data-mt-reveal]').forEach((element) => revealObserver.observe(element));
  }

  const focusConfirmation = () => {
    const confirmation = document.getElementById('guest-list-thanks');
    if (!confirmation) return;
    const skipLink = document.querySelector('.skip-link');
    if (skipLink) {
      skipLink.href = '#guest-list-thanks';
      skipLink.textContent = 'Skip to signup confirmation';
    }
    document.title = 'You\'re on the guest list - Mosey & Tuck';
    confirmation.focus({ preventScroll: true });
  };

  const signup = document.getElementById('MoseyGuestList');
  const successTemplate = document.getElementById('MoseyGuestListSuccess');
  if (signup && successTemplate && signup.dataset.companyId && signup.dataset.listId) {
    const email = signup.querySelector('input[type="email"]');
    const button = signup.querySelector('button[type="submit"]');
    const status = signup.querySelector('#form-status');
    let submitting = false;

    signup.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting || !signup.reportValidity()) return;

      submitting = true;
      button.disabled = true;
      signup.setAttribute('aria-busy', 'true');
      status.removeAttribute('data-state');
      status.textContent = 'Joining the guest list...';

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(signup.dataset.companyId)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            signal: controller.signal,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Mosey & Tuck homepage guest list',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email.value.trim(),
                      },
                    },
                  },
                },
                relationships: {
                  list: { data: { type: 'list', id: signup.dataset.listId } },
                },
              },
            }),
          }
        );

        if (response.status !== 202) {
          const error = new Error('Subscription was not accepted');
          error.rateLimited = response.status === 429;
          throw error;
        }

        signup.replaceChildren(successTemplate.content.cloneNode(true));
        signup.removeAttribute('aria-busy');
        focusConfirmation();
      } catch (error) {
        status.dataset.state = 'error';
        status.textContent = error.rateLimited
          ? 'Please wait a moment, then try joining again.'
          : 'We couldn\'t confirm your signup. Please try again, or email hello@moseyandtuck.com.';
        signup.removeAttribute('aria-busy');
        button.disabled = false;
        submitting = false;
      } finally {
        window.clearTimeout(timeout);
      }
    });

    email.disabled = false;
    button.disabled = false;
  }

  focusConfirmation();
})();



